import React from 'react';
import { FormControl, InputLabel, Select, MenuItem, Grid } from '@mui/material';

import { Vob, Payor, Plan, PayorPlan } from '@finpay-estimation/estimation-types';
import { useVobData } from '../hooks/useVobData';

interface Facility {
    facilityId: number;
    facilityName: string;
}

interface VOBSelectorProps {
    selectedVOB: string;
    onVOBChange: (vobId: string) => void;
    rateAsPayorPlan?: PayorPlan | null;
    facilities: Facility[];
}

export const VOBSelector: React.FC<VOBSelectorProps> = ({
    selectedVOB,
    onVOBChange,
    rateAsPayorPlan,
    facilities
}) => {
    const { getVobDisplayText, vobs, vobsLoading } = useVobData({ 
        facilities, 
        includeReduxVobs: true 
    });

    if (vobsLoading) {
        return (
            <Grid container spacing={2} sx={{ mb: 3 }}>
                <Grid item xs={12}>
                    <FormControl fullWidth size="small" disabled>
                        <InputLabel id="vob-select-label">Loading VOBs...</InputLabel>
                        <Select
                            test-id="vob-select-loading"
                            labelId="vob-select-label"
                            id="vob-select"
                            value=""
                            label="Loading VOBs..."
                        >
                        </Select>
                    </FormControl>
                </Grid>
            </Grid>
        );
    }

    return (
        <Grid container spacing={2} sx={{ mb: 3 }} style={{marginBottom: "16px"}}>
            <Grid item xs={12}>
                <FormControl fullWidth size="small">
                    <InputLabel id="vob-select-label">VOB</InputLabel>
                    <Select
                        test-id="vob-select"
                        labelId="vob-select-label"
                        id="vob-select"
                        value={selectedVOB}
                        label="VOB"
                        onChange={(e) => onVOBChange(e.target.value)}
                        sx={{
                            '& .MuiSelect-select': {
                                overflow: 'hidden',
                                textOverflow: 'ellipsis',
                                whiteSpace: 'nowrap'
                            }
                        }}
                    >
                        {(vobs || []).map((vob, index) => (
                            <MenuItem 
                                key={index} 
                                value={vob.vobId}
                                test-id={`vob-option-${index}`}
                                sx={{
                                    maxWidth: '100%',
                                    overflow: 'hidden',
                                    textOverflow: 'ellipsis',
                                    whiteSpace: 'nowrap',
                                    '& .MuiTypography-root': {
                                        overflow: 'hidden',
                                        textOverflow: 'ellipsis',
                                        whiteSpace: 'nowrap'
                                    }
                                }}
                            >
                                {getVobDisplayText(vob)}
                            </MenuItem>
                        ))}
                    </Select>
                </FormControl>
            </Grid>
        </Grid>
    );
};